export default __webpack_public_path__ + "static/media/sew_on_snap.b25d7fe0.webp";